<template>
    <div id="journal_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="journalHeader" v-if="$route.params.id > 0">Update Journal</span>
                    <span class="page-title" id="journalHeader" v-else>Add Journal</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content journal-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form journal-form" id="journalForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div v-if="$route.params.id > 0" class="col form-group mt-4">
                                        <label class="control-label" for="journal_number">Journal #: </label>
                                        <span class="label font-bold">{{journal_number}}</span>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="account_type">Module:</label>
                                        <v-select v-model="module_id" name="module_id" placeholder="Select Module."
                                                label="text"
                                                :options="modulesArr" id="module_id" @input="onModuleChange()" :disabled="disableField">
                                        </v-select>
                                        <div class="field-error">{{module_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="reference_id">Reference {{referenceTitle}}:</label>
                                        <v-select v-model="reference_id" name="reference_id" id="reference_id" label="text" :filterable="false" :options="referencesArr" @search="onSearchReference" placeholder="Select Reference" class='custom-ci-auto-search close-remove' :disabled="disableField">
                                            <template slot="no-options">
                                                Search Reference...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ reference_error_msg }}</div>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label require">Post Date</label>
                                        <div class="input-group">
                                            <template v-if="disableField">
                                                <date-picker placeholder="MM/DD/YYYY" id="post_date" name="post_date" v-model="post_date" :config="optionsDate" aria-describedby="basic-addon3" disabled></date-picker>
                                                <label for="post_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                            </template>
                                            <template v-else>
                                                <date-picker placeholder="MM/DD/YYYY" id="post_date" name="post_date" v-model="post_date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                                <label for="post_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                            </template>
                                        </div>
                                        <div class="field-error">{{post_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group" v-if="disableFPField == true">
                                        <label class="control-label require">Fiscal Period</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/YYYY" id="fiscal_date" name="fiscal_date" v-model="fiscal_date" :config="optionsPiscalDate" aria-describedby="basic-addon3" ></date-picker>
                                            <label for="fiscal_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{fiscal_date_error_msg}}</div>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="state">Location:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text" :options="locationArr">
                                        </v-select>
                                        <div class="field-error">{{location_error_msg}}</div>
                                    </div> -->
                                    <div class="col-md-3 form-group">
                                        <label class="control-label">Reverse: [Y/N]</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="is_reverse">
                                                    Yes
                                                    <input type="radio" v-model="is_reverse" :value="'yes'" id="is_reverse" name="is_reverse">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="is_reverse">
                                                    No
                                                    <input type="radio" v-model="is_reverse" :value="'no'" id="is_reverse2" name="is_reverse">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div v-if="$route.params.id == undefined" class="clearfix"></div> -->
                                    <div class="col form-group">
                                        <label class="control-label" for="jedescription">Paste Excel Rows:</label>
                                        <textarea class='form-control' v-model="jedescription" ref="jedescription" id="jedescription" rows="3" @input="addCpiedRows()"></textarea>
                                        <div class="field-error">{{jedescription_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="header_desc">Description:</label>
                                        <textarea class='form-control' v-model="header_desc" ref="header_desc" id="header_desc" rows="3"></textarea>
                                        <div class="field-error">{{desc_error_msg}}</div>
                                    </div>
                                    <div class="col-md-8 form-group">
                                      <div class="order-summary">
                                        <div class="row">
                                            <div class="col-md-10 offset-md-3">
                                                <div class="bg-white radius-5 p-3">
                                                    <label class="font-bold"> SUMMARY </label>
                                                    <table aria-describedby="table" class="table table-sm table-bordered">
                                                        <tr class="table-secondary">
                                                            <th></th>
                                                            <th class="text-right">Debit</th>
                                                            <th class="text-right">Credit</th>
                                                            <th class="text-right">Difference</th>
                                                        </tr>
                                                        <tr>
                                                            <td> Total: </td>
                                                            <!-- <td class="order-total text-right"> ${{debitSubTotal}} </td>
                                                            <td class="order-total text-right"> ${{creditSubTotal}} </td> -->
                                                            <td class="order-total text-right"> ${{displayDebit}} </td>
                                                            <td class="order-total text-right"> ${{displayCredit}} </td>
                                                            <td class="order-total text-right"> ${{difference}} </td>
                                                        </tr>
                                                        <!-- <tr>
                                                            <td> Total: </td>
                                                            <td class="order-total text-right"> ${{debitTotal}} </td>
                                                            <td class="order-total text-right"> ${{creditTotal}} </td>
                                                        </tr> -->
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="vehicle_id">Asset:</label>
                                        <v-select v-model="vehicle_id" id="vehicle_select" name="vehicle_id" label="text" :filterable="false" :options="vehicleArr" @search="onSearchAsset" placeholder="Select Asset" class='custom-ci-auto-search close-remove'>
                                            <template slot="no-options">
                                                Search Asset...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ vehicle_error_msg }}</div>
                                    </div>  -->
                                </div>
                                <div class="purchase-order-create-main table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require" style="width:300px">GL Account</th>
                                                <th scope="col" >Description</th>
                                                <th scope="col" style="width:300px">Unit</th>
                                                <th scope="col" class="require">Debit</th>
                                                <th scope="col" class="require">Credit</th>
                                                <th scope="col">Is Capital Cost</th>
                                                <th scope="col"> Action </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in rows" :key="index">
                                                <td>
                                                    <v-select v-model="row.account" name="account" id="account"
                                                                label="text" :filterable="false" :options="accountsArr"
                                                                @search="onSearchAccount"
                                                                placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                                        <template slot="no-options">
                                                        Search Account...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{row.account_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="Description" v-model="row.description" id="description" class="form-control">
                                                    <div class="field-error">{{row.description_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <div class="col form-group">
                                                        <!-- <label class="control-label" for="vehicle_id">Asset:</label> -->
                                                        <v-select v-model="row.vehicle_id" id="vehicle_select" name="vehicle_id" label="text" :filterable="false" :options="vehicleArr" @search="onSearchAsset" placeholder="Select Asset" class='custom-ci-auto-search close-remove'>
                                                            <template slot="no-options">
                                                                Search Asset...
                                                            </template>
                                                            <template slot="option" slot-scope="option">
                                                                <div class="d-center">
                                                                    {{ option.text }}
                                                                </div>
                                                            </template>
                                                            <template slot="selected-option" slot-scope="option">
                                                                <div class="selected d-center">
                                                                    {{ option.text }}
                                                                </div>
                                                            </template>
                                                        </v-select>
                                                        <div class="field-error">{{ row.vehicle_error_msg }}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <template v-if="row.debitDisabled == 0">
                                                        <input type="text" placeholder="0.00" v-model="row.debit" id="debit" class="form-control text-right" @keypress="isNumberOnly($event)" @input="onDebitInput($event,index)" @blur="leaveFocusAmt($event,index,'debit')">
                                                    </template>
                                                    <template v-else>
                                                        <input type="text" placeholder="0.00"  v-model="row.debit" id="debit" class="form-control text-right" disabled>
                                                    </template>
                                                    <div class="field-error">{{row.debit_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <template v-if="row.creditDisabled == 0">
                                                        <input type="text" placeholder="0.00" v-model="row.credit"  id="credit" class="form-control text-right" @keypress="isNumberOnly($event)" @input="onCreditInput($event,index)" @blur="leaveFocusAmt($event,index,'credit')">
                                                    </template>
                                                    <template v-else>
                                                        <input type="text" placeholder="0.00"  v-model="row.credit" id="credit" class="form-control text-right" disabled>
                                                    </template>
                                                    <div class="field-error">{{row.credit_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <template>
                                                        <div class="form-check">
                                                            <label class="checkbox-custom">
                                                                <input type="checkbox" v-model="row.is_cap_cost" id="is_cap_cost" name="is_cap_cost">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </template>
                                                </td>
                                                <td class="text-center">
                                                    <template v-if="rows.length != 1">
                                                        <a href="javascript:void(0);" v-on:click="removeItem(index);"><i class="fp-remove"></i> </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                        <i class="fp-add"></i> Add Line Item
                                    </button>
                                </div>

                                <div class="field-error">{{common_error_msg}}</div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateJournalBtn" v-if="$route.params.id != undefined && $route.params.id != ''" class="btn btn-primary" v-on:click.prevent="CreateJournal" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateJournalBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateJournal" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueJournalBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateJournal(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelJournalBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import moment from 'moment';
export default {
    name: "JournalCreate",
    metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Journal | " +process.env.COPYRIGHT_NAME : "Create Journal | " +process.env.COPYRIGHT_NAME
        }
    },
    
    mixins:[commonMixins,contractMixins],
    data: () => ({
        difference: "",
        permissions: [],
        cantAccessPage: "",
        loading:false,
        module_id:null,
        module_error_msg:"",
        reference_id:null,
        referencesArr:[],
        reference_error_msg:"",
        rows:[],
        accountsArr:[],
        post_date:"",
        post_date_error_msg:"",
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        optionsPiscalDate:{
            format: 'MM/YYYY',
            useCurrent: true,
        },
        fiscal_date:'',
        common_error_msg:"",
        referenceTitle:"",
        journalStatusArr:[
            {text:"Posted",value:"posted"}
        ],
        disableField:false,
        disableFPField:true,
        jedescription:"",
        jedescription_error_msg:"",
        desc_error_msg :"",
        fiscal_date_error_msg:"",
        status_error_msg:"",
        debitSubTotal:0,
        debitTotal:0,
        creditSubTotal:0,
        creditTotal:0,
        status:"",
        journal_number:"",
        //location_id:'',
        //locationArr:[],
        location_error_msg:'',
        accountCanChanged:false,
        vehicle_id:'',
        vehicleArr:[],
        vehicle_error_msg:"",
        glAccountArr:[],
        allVehicleArr:[],
        is_reverse:'no',
        header_desc:"",
        displayDebit:"",
        displayCredit:"",
        for: "",
        // reqClass:"require",
        batch:"",
        journal_type:""
    }),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_journal') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
        rows: {
            handler: function (val, oldVal) {
              console.log("HANDLE");
                var self = this;
                var debitTotal = 0;
                var creditTotal = 0
                for (var j = 0; j < val.length; j++) {
                  console.log("debit == ", val[j]);
                    if (val[j].debitDisabled == 0) {
                        if (val[j].debit != "" && val[j].debit != "." && val[j].debit != "-") {
                            debitTotal += Number(val[j].debit.replace(/\,/g,""));
                            console.log("debitTotal == ", debitTotal);
                        }
                    }
                    console.log("credit  == ", val[j].credit);
                    if (val[j].creditDisabled == 0) {
                        if (val[j].credit != "" && val[j].credit != "." && val[j].credit != "-") {
                            creditTotal += Number(val[j].credit.replace(/\,/g,""));
                            console.log("creditTotal == ", creditTotal);
                        }
                    }
                }




                self.debitSubTotal = debitTotal.toFixed(2);
                self.creditSubTotal = creditTotal.toFixed(2);

                var debitTotalUpdate = debitTotal - Number(self.creditSubTotal);
                var creditTotalUpdate = creditTotal - Number(self.debitSubTotal);

                if (debitTotalUpdate == 0 || (Number(self.debitTotal) > Number(creditTotal)) || (Number(self.debitSubTotal) > Number(self.creditSubTotal)) ) {
                    self.debitTotal = self.debitSubTotal;
                }else{
                    self.debitTotal = debitTotalUpdate.toFixed(2);
                }

                if (creditTotalUpdate == 0 || (Number(self.creditTotal) > Number(debitTotal)) || (Number(self.creditSubTotal) > Number(self.debitSubTotal)) ) {
                    self.creditTotal = self.creditSubTotal;
                }else{
                    self.creditTotal = creditTotalUpdate.toFixed(2);
                }

                self.displayDebit = self.amountFormat(self.debitSubTotal);
                self.displayCredit = self.amountFormat(self.creditSubTotal);
                if(self.displayCredit == "" && self.displayDebit == "") {
                  self.difference = self.amountFormat("0");
                } else {
                  self.difference = self.amountFormat(self.removeFormat(self.displayCredit) - self.removeFormat(self.displayDebit));
                }

            },
            deep: true
        },
        // location_id:function(val){

        //     var self = this;
        //     if (self.$route.params.id != undefined && self.accountCanChanged == false){
        //         return;
        //     }

        //     if (val.value != undefined){
        //         if (self.rows.length > 1){
        //             for(var i=0;i < self.rows.length; i++){
        //                 self.rows[i].account = '';
        //             }
        //         }
        //     }
        // },
        // post_date:function(val){
        //     var self = this;

        //     if (val != null && val != undefined){
        //         // self.fiscal_date = self.formatDate(val);
        //         $("#fiscal_date").val(self.formatDate(val));
        //     }
        // },
   },
   created: function() {

   },
   mounted: function() {
        var self = this;
        self.getPermissions();

        self.loadFieldData(['location']);
        var path = window.location.pathname;
        var segments = path.split("/");

        if (self.$route.query.for == 'recurring') {
            console.log("here");
            self.disableFPField = false;
            self.for = "recurring";
            // self.reqClass = "";
        }

        if (segments[3]) {
            setTimeout(function () {
                self.loadJournal();
            }, 100);
        }else{
            self.rows.push({
                journal_item_id:0,
                account:"",
                account_error_msg:"",
                debit:"",
                debit_error_msg:"",
                credit:"",
                credit_error_msg:"",
                description:"",
                description_error_msg:"",
                debitDisabled:0,
                creditDisabled:0,
                vehicle_id:'',
                vehicle_error_msg:'',
                is_cap_cost:false
            },{
                journal_item_id:0,
                account:"",
                account_error_msg:"",
                debit:"",
                debit_error_msg:"",
                credit:"",
                credit_error_msg:"",
                description:"",
                description_error_msg:"",
                debitDisabled:0,
                creditDisabled:0,
                vehicle_id:'',
                vehicle_error_msg:'',
                is_cap_cost:false
            });
            var todayDate = self.getTodayDate();
            var postDate = moment(todayDate,"MM/DD/YYYY");
            self.post_date = postDate._i;
            // self.fiscal_date = self.formatDate(self.post_date);
            // self.dateChanged(self.post_date);
        }

    },
    methods: {
        onSearchReference(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                // self.searchField(loading, search, 'invoice', '');
                if (self.module_id != null && self.module_id.value != '') {
                    $.ajax({
                        url: process.env.ROOT_API + "/reference/search",
                        type: "POST",
                        headers: this.ajxHeaders,
                        crossDomain: true,
                        dataType:"json",
                        async:true,
                        data:{
                            module:self.module_id.value,
                            search:search
                        },
                        success: function (data) {

                            loading(false);
                            self.referencesArr = data.content;
                        },
                        error: function (jqXHR, exception) {
                            self.Registerbtn = "Register";
                            self.generateStatusCodeMessage(jqXHR,true,'journal-on-search-referance')
                        }
                    });
                }else{
                    loading(false);
                }
            }
        },

        onSearchAccount(search, loading) {
            var self = this;
            if (search.length > 3) {

                loading(true);
                self.searchField(loading, search, 'accounts', '');

            }
        },
        BackJournalsList() {
            var self = this;
            if(self.for != "" && self.for != null) {
              self.$router.push("/journal-recurring/list");
            } else {
              self.$router.push("/journal/list");
            }

        },
        addRow: function () {
            var self = this;
            var index = self.rows.length-1;

            if (self.rows.length < 1) {

                self.rows.push({
                    journal_item_id:0,
                    account:"",
                    account_error_msg:"",
                    debit:"",
                    debit_error_msg:"",
                    credit:"",
                    credit_error_msg:"",
                    description:"",
                    description_error_msg:"",
                    debitDisabled:0,
                    creditDisabled:0,
                    vehicle_id:'',
                    vehicle_error_msg:'',
                    is_cap_cost:false
                },{
                    journal_item_id:0,
                    account:"",
                    account_error_msg:"",
                    debit:"",
                    debit_error_msg:"",
                    credit:"",
                    credit_error_msg:"",
                    description:"",
                    description_error_msg:"",
                    debitDisabled:0,
                    creditDisabled:0,
                    vehicle_id:'',
                    vehicle_error_msg:'',
                    is_cap_cost:false
                });

            }else{
                self.rows[index].account_error_msg = "";
                self.rows[index].debit_error_msg = "";
                self.rows[index].credit_error_msg = "";
                self.rows[index].description_error_msg = "";
                self.rows[index].vehicle_error_msg = "";
                self.common_error_msg = "";

                if (self.rows[index].account != null && self.rows[index].account.value
                        && (self.rows[index].debitDisabled == 1 || self.rows[index].creditDisabled == 1 )
                        && (self.rows[index].is_cap_cost == false || (self.rows[index].is_cap_cost == true && self.rows[index].vehicle_id != null && self.rows[index].vehicle_id.value))) {

                    self.rows.push({
                        journal_item_id:0,
                        account:"",
                        account_error_msg:"",
                        debit:"",
                        debit_error_msg:"",
                        credit:"",
                        credit_error_msg:"",
                        description:"",
                        description_error_msg:"",
                        debitDisabled:0,
                        creditDisabled:0,
                        vehicle_id:'',
                        vehicle_error_msg:'',
                        is_cap_cost:false
                    },{
                        journal_item_id:0,
                        account:"",
                        account_error_msg:"",
                        debit:"",
                        debit_error_msg:"",
                        credit:"",
                        credit_error_msg:"",
                        description:"",
                        description_error_msg:"",
                        debitDisabled:0,
                        creditDisabled:0,
                        vehicle_id:'',
                        vehicle_error_msg:'',
                        is_cap_cost:false
                    });

                }else{

                    if ( self.rows[index].account == null || !self.rows[index].account.value ) {
                        self.rows[index].account_error_msg = "GL Account Required.";
                    }
                    if ( self.rows[index].debitDisabled == 0 && self.rows[index].creditDisabled == 0 ) {
                        self.rows[index].debit_error_msg = "Debit Required.";
                        self.rows[index].credit_error_msg = "Credit Required.";
                    }
                    // if ( self.rows[index].debit == null || String(self.rows[index].debit) == "" ) {
                    //     self.rows[index].debit_error_msg = "Debit Required.";
                    // }
                    // if ( self.rows[index].credit == null || String(self.rows[index].credit) == "") {
                    //     self.rows[index].credit_error_msg = "Credit Required.";
                    // }
                    // if ( self.for == "" || self.for == null ) {
                    //     if ( self.rows[index].description == null || self.rows[index].description.trim() == "" ) {
                    //         self.rows[index].description_error_msg = "Description Required.";
                    //     }
                    // }

                    // if (String(self.rows[index].debit) != "" && parseFloat(self.rows[index].debit) == 0 && String(self.rows[index].credit) != "" && parseFloat(self.rows[index].credit) == 0) {
                    //     self.rows[index].debit_error_msg = "Debit and Credit Amount Both Cannot Be 0."
                    // }
                    // if (String(self.rows[index].debit) != "" && String(self.rows[index].credit) != "" && (self.rows[index].debit > 0 && self.rows[index].credit > 0)) {
                    //     self.rows[index].credit_error_msg = "Either of Debit or Credit Amount Must Be 0."
                    // }
                    if (self.rows[index].is_cap_cost == true && (self.rows[index].vehicle_id == null || !self.rows[index].vehicle_id.value) ) {
                        self.rows[index].vehicle_error_msg = "Asset Required";
                    }
                }
            }
        },
        removeItem: function (index) {
            var self = this;
            if(self.rows.length > 1) {

                if (self.rows[index].journal_item_id == 0) {
                    self.rows.splice(index, 1);

                }else {

                    if (confirm('Are you sure that you want to remove this item?')) {

                        self.loading = true;
                        var url = "";
                        if ( self.for == "recurring" ) {
                            url = "/journal-recurring/item/delete";
                        } else {
                            url = "/journal/item/delete";
                        }

                        $.ajax({
                            url: process.env.ROOT_API + url,
                            type: "POST",
                            data: {
                                'journal_item_id': self.rows[index].journal_item_id,
                            },
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                if (data.status == "success") {

                                    setTimeout(function () {
                                        self.loadJournal();
                                    },50);

                                }else{
                                    self.loading = false;
                                    self.$swal('',data.content,'info');
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'journal-item-delete')
                            },
                        });
                    }
                }
            }
        },
        isNumberCheck: function(evt) {

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1) && (charCode !== 44)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        onModuleChange() {
            var self = this;
            self.reference_id = null;
            // self.post_date = "";
            self.module_error_msg = "";
            self.reference_error_msg = "";
            self.post_date_error_msg = "";
            self.status_error_msg = "";
            self.common_error_msg = "";
            self.referencesArr = [];
            self.jedescription_error_msg = "";
            self.desc_error_msg = "";
            self.fiscal_date_error_msg = "";
            // self.rows = [];
            // self.rows.push({
            //     journal_item_id:0,
            //     account:"",
            //     account_error_msg:"",
            //     debit:"",
            //     debit_error_msg:"",
            //     credit:"",
            //     credit_error_msg:"",
            //     description:"",
            //     description_error_msg:"",
            //     debitDisabled:0,
            //     creditDisabled:0
            // });
            if (self.module_id != null) {
                if (self.module_id.value == "invoice") {
                    self.referenceTitle = "Search with Invoice #";
                }else if(self.module_id.value == "vendor invoice"){
                    self.referenceTitle = "Search with Voucher Number #";
                }else if(self.module_id.value == "permit customer mapper"){
                    self.referenceTitle = "Search with Permit Number #";
                }else if(self.module_id.value == "processed hvut schedule"){
                    self.referenceTitle = "Search with Unit Number #";
                }else if(self.module_id.value == "asset"){
                    self.referenceTitle = "Search with Unit Number #";
                }
            }else{
                self.referenceTitle = "";
            }

        },
        CreateJournal(flag){
            var self = this;
            var error = false;
            self.module_error_msg = "";
            self.reference_error_msg = "";
            self.post_date_error_msg = "";
            self.common_error_msg = "";
            self.status_error_msg = "";
            self.jedescription_error_msg = "";
            self.desc_error_msg = "";
            self.fiscal_date_error_msg = "";

            /*if (!self.module_id || self.module_id == null || self.module_id == "") {
                self.module_error_msg = "Module Required.";
                error = true;
            }

            if (!self.reference_id || self.reference_id == null || self.reference_id.value == "") {
                self.reference_error_msg = "Reference Required.";
                error = true;
            }*/
            // if (self.module_id != null && self.module_id.value) {
            //     if (!self.reference_id || self.reference_id == null || self.reference_id.value == "") {
            //         self.reference_error_msg = "Reference Required.";
            //         error = true;
            //     }
            // }

            if (!self.post_date || self.post_date == null || self.post_date == "") {
                self.post_date_error_msg = "Post Date Required.";
                error = true;
            }
            if (!self.header_desc || self.header_desc == null || self.header_desc == "") {
                self.desc_error_msg = "Description Required.";
                error = true;
            }
            if(self.disableFPField == true){
                if (!self.fiscal_date || self.fiscal_date == null || self.fiscal_date == "") {
                    self.fiscal_date_error_msg = "Fiscal Date Required.";
                    error = true;
                }
            }

            var totalDebitAmount = 0;
            var totalCreditAmount = 0;
            var creditAccountsArr = [];
            var debitAccountsArr = [];

            if (self.rows.length < 1) {
                self.common_error_msg = "Journal Items Required."
                error = true;
            }

            for(var i = 0;i<self.rows.length;i++) {

                self.rows[i].account_error_msg = "";
                self.rows[i].debit_error_msg = "";
                self.rows[i].credit_error_msg = "";
                self.rows[i].description_error_msg = "";
                self.rows[i].vehicle_error_msg = "";

                if ( self.rows[i].account == null || self.rows[i].account == "" ) {
                    self.rows[i].account_error_msg = "GL Account Required.";
                    error = true;
                }
                if ( self.rows[i].debitDisabled == 0 && self.rows[i].creditDisabled == 0 ) {
                    self.rows[i].debit_error_msg = "Debit Required.";
                    self.rows[i].credit_error_msg = "Credit Required.";
                    error = true;
                }
                // if ( self.rows[i].debit == null || String(self.rows[i].debit) == "" ) {
                //     self.rows[i].debit_error_msg = "Debit Required.";
                //     error = true;
                // }
                // if ( self.rows[i].credit == null || String(self.rows[i].credit) == "") {
                //     self.rows[i].credit_error_msg = "Credit Required.";
                //     error = true;
                // }
                // if ((self.rows[i].description == null || self.rows[i].description.trim() == "") && self.for == "" ) {
                //     self.rows[i].description_error_msg = "Description Required.";
                //     error = true;
                // }

                if (self.rows[i].is_cap_cost == true && (self.rows[i].vehicle_id == null || !self.rows[i].vehicle_id.value)) {
                    self.rows[i].vehicle_error_msg = "Asset Required";
                    error = true;
                }
                // if (String(self.rows[i].debit) != "" && self.rows[i].debit == 0 && String(self.rows[i].credit) != "" && self.rows[i].credit == 0) {
                //     self.rows[i].debit_error_msg = "Debit and Credit Amount Both Cannot Be 0."
                // }

                // if (String(self.rows[i].debit) != "" && String(self.rows[i].credit) != "" && (self.rows[i].debit == self.rows[i].credit)) {
                //     self.rows[i].debit_error_msg = "Debit and Credit Amount Both Cannot Be Same."
                // }

                // if (String(self.rows[i].debit) != "" && String(self.rows[i].credit) != "" && (self.rows[i].debit > 0 && self.rows[i].credit > 0)) {
                //     self.rows[i].credit_error_msg = "Either of Debit or Credit Amount Must Be 0."
                // }

            }
            var glSrc = 'J';//gl source is J
            var isCapCostCount = 0;
            for(var i = 0;i<self.rows.length;i++) {
                //credit and debit total if input is not disabled
                if (self.rows[i].debitDisabled == 0 && self.rows[i].debit.trim() != "") {
                    var lineDebitAmt = self.rows[i].debit.replaceAll(",","");
                    totalDebitAmount += parseFloat(lineDebitAmt);
                }
                if (self.rows[i].creditDisabled == 0 && self.rows[i].credit.trim() != "") {
                    var lineCreditAmt = self.rows[i].credit.replaceAll(",","");
                    totalCreditAmount += parseFloat(lineCreditAmt);
                }
                if ( parseFloat(self.rows[i].debit) != 0 ) {
                    debitAccountsArr.push(self.rows[i].account.value);
                }else {
                    creditAccountsArr.push(self.rows[i].account.value);
                }
                //check whether any rows with cap cost true found
                if (self.rows[i].is_cap_cost == true && self.rows[i].vehicle_id != null) {
                    isCapCostCount++;
                }
            }
            //if any cap cost item selected
            // if (isCapCostCount > 0) {
            //     glSrc = 'D';//gl source is D
            // }

            let debitArrDuplicate = debitAccountsArr.some((val, i) => debitAccountsArr.indexOf(val) !== i);
            let creditArrDuplicate = creditAccountsArr.some((val, i) => creditAccountsArr.indexOf(val) !== i);
            let debitCreditArr = debitAccountsArr.filter(x => creditAccountsArr.includes(x));
            console.log("debitCreditArr ==", debitCreditArr);

            if (totalDebitAmount != 0 && totalCreditAmount == 0) {
                self.common_error_msg = "Credit Amount Entry Must Be Entered Against Debit Amount Entry."
                error = true;
            }

            if (totalCreditAmount != 0 && totalDebitAmount == 0) {
                self.common_error_msg = "Debit Amount Entry Must Be Entered Against Credit Amount Entry."
                error = true;
            }

            if (totalDebitAmount != 0 && totalCreditAmount != 0 && (Math.abs(totalDebitAmount.toFixed(4)) != Math.abs(totalCreditAmount.toFixed(4)))) {
                self.common_error_msg = "Total Amount For Debit and Credit must be same."
                error = true;
            }

            if (!error) {
                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");

                if (segments[3])
                {
                    $("#CreateJournalBtn").val("Updating ...");
                    $("#CreateJournalBtn").prop("disabled", true);
                    $("#cancelJournalBtn").prop("disabled",true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinueJournalBtn").val("Saving ...");
                        $("#CreateJournalBtn").prop("disabled", true);
                        $("#createAndContinueJournalBtn").prop("disabled", true);
                        $("#cancelJournalBtn").prop("disabled",true);

                    } else{

                        $("#CreateJournalBtn").val("Saving ...");
                        $("#CreateJournalBtn").prop("disabled", true);
                        $("#createAndContinueJournalBtn").prop("disabled", true);
                        $("#cancelJournalBtn").prop("disabled",true);
                    }
                }

                var fields = $("#journalForm").serializeArray();
                // if (self.module_id != null && self.module_id.value) {
                //     fields.push({name: "module_id", value: self.module_id.value});
                //     fields.push({name: "type", value: "module"});
                // }else{
                    fields.push({name: "type", value: "general"});
                // }
                // if (self.reference_id != null && self.reference_id.value) {
                //     fields.push({name: "reference_id", value: self.reference_id.value});
                // }
                // if (self.location_id != null && self.location_id.value) {
                //     fields.push({name: "location_id", value: self.location_id.value});
                // }
                fields.push({name: "gl_src", value:glSrc});
                fields.push({name: "post_date", value: self.post_date});
                fields.push({name: "fiscal_date", value: self.fiscal_date});
                fields.push({name: "header_desc", value:self.header_desc});
                if (self.vehicle_id != null && self.vehicle_id.value){
                    fields.push({name: "vehicle_id", value:self.vehicle_id.value});
                }
                fields.push({name: "journalItems", value: JSON.stringify(self.rows)});
                fields.push({ name: "jv_number", value: segments[3] });
                fields.push({name:"journal_type",value: self.journal_type})

                console.log(fields);

                var createUrl = "/journal/create";
                if(self.for != "" && self.for != null) {
                  createUrl = "/journal/recurring/create";
                  fields.push({ name: "id", value: segments[3] });
                } else {
                  createUrl = "/journal/create";
                  fields.push({ name: "id", value: self.batch });
                }

                $.ajax({
                    url: process.env.ROOT_API + createUrl,
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;
                        // return;
                        if (segments[3])
                        {
                            $("#CreateJournalBtn").val("Update");
                            $("#CreateJournalBtn").prop("disabled", false);
                            $("#cancelJournalBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#createAndContinueJournalBtn").val("Save and Continue");
                                $("#CreateJournalBtn").prop("disabled", false);
                                $("#createAndContinueJournalBtn").prop("disabled", false);
                                $("#cancelJournalBtn").prop("disabled",false);

                            } else{

                                $("#CreateJournalBtn").val("Save");
                                $("#CreateJournalBtn").prop("disabled", false);
                                $("#createAndContinueJournalBtn").prop("disabled", false);
                                $("#cancelJournalBtn").prop("disabled",false);

                            }
                        }

                        if (data.status == "success") {

                            if (flag == "Save and Continue") {

                                $("#journalForm").trigger("reset");
                                // self.module_id = null;
                                // self.reference_id = null;
                                self.rows=[];
                                self.rows.push({
                                    journal_item_id:0,
                                    account:"",
                                    account_error_msg:"",
                                    debit:"",
                                    debit_error_msg:"",
                                    credit:"",
                                    credit_error_msg:"",
                                    description:"",
                                    description_error_msg:"",
                                    debitDisabled:0,
                                    creditDisabled:0,
                                    vehicle_id:'',
                                    vehicle_error_msg:'',
                                    is_cap_cost:false
                                },{
                                    journal_item_id:0,
                                    account:"",
                                    account_error_msg:"",
                                    debit:"",
                                    debit_error_msg:"",
                                    credit:"",
                                    credit_error_msg:"",
                                    description:"",
                                    description_error_msg:"",
                                    debitDisabled:0,
                                    creditDisabled:0,
                                    vehicle_id:'',
                                    vehicle_error_msg:'',
                                    is_cap_cost:false
                                });
                                self.referenceTitle = "";
                                self.jedescription = "";
                                self.is_reverse = 'no';
                                self.header_desc = "";
                                $('#is_reverse2').prop('checked', true);

                            } else{

                              if(self.for != "" && self.for != null) {
                                self.$router.push("/journal-recurring/list");
                              } else {
                                self.$router.push("/journal/list");
                              }
                            }

                        } else {

                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                    self.common_error_msg += data.content[i] + "\n";
                                }
                                // $("#errorMsg").html(err);
                                // $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    // $(".alert-warning").removeClass("show");
                                    // $(".alert-warning").addClass("hide");
                                    self.common_error_msg = "";
                                }, 10000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (segments[3])
                        {
                            $("#CreateJournalBtn").val("Update");
                            $("#CreateJournalBtn").prop("disabled", false);
                            $("#cancelJournalBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#PurchaseOrderForm").trigger("reset");
                                $("#createAndContinueJournalBtn").val("Save and Continue");
                                $("#CreateJournalBtn").prop("disabled", false);
                                $("#createAndContinueJournalBtn").prop("disabled", false);
                                $("#cancelJournalBtn").prop("disabled",false);

                            } else{

                                $("#CreateJournalBtn").val("Save");
                                $("#CreateJournalBtn").prop("disabled", false);
                                $("#createAndContinueJournalBtn").prop("disabled", false);
                                $("#cancelJournalBtn").prop("disabled",false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,true,'journal-create')
                    }
                });

            }else{
            self.errorValidationFocus();
        }

        },
        loadJournal() {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;

            var CallUrl = "/journal/" + segments[3];
            if(self.for != "" && self.for != null) {
              CallUrl = "/journal-recurring/" + segments[3];
            }
            $.ajax({
                url: process.env.ROOT_API + CallUrl,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {
                        //if sub system is closed for post date of journal
                        if (data.content.is_editable != undefined && data.content.is_editable != null) {
                            if (data.content.is_editable == 0) {
                                self.cantAccessPage = false;
                                return;
                            }
                        }

                        self.journal_number = data.content.journal_number;
                        // if (data.content.module_value != null) {
                        //     self.module_id = {text:data.content.module_text,value:data.content.module_value};
                        //     self.reference_id = {text:data.content.reference_text,value:data.content.reference_value};
                        //     if (self.module_id.value == "invoice") {
                        //         self.referenceTitle = "Search with Invoice #";
                        //     }else if(self.module_id.value == "vendor invoice"){
                        //         self.referenceTitle = "Search with Voucher Number #";
                        //     }else if(self.module_id.value == "permit customer mapper"){
                        //         self.referenceTitle = "Search with Permit Number #";
                        //     }else if(self.module_id.value == "processed hvut schedule"){
                        //         self.referenceTitle = "Search with Unit Number #";
                        //     }else if(self.module_id.value == "asset"){
                        //         self.referenceTitle = "Search with Unit Number #";
                        //     }
                        // }else{
                        //     self.referenceTitle = "";
                        // }
                        self.post_date = data.content.post_date;
                        self.fiscal_date = data.content.fiscal_month + ' / ' + data.content.fiscal_year;
                        //self.location_id = {text:data.content.locationName,value:data.content.locationId};
                        if  (data.content.vehicle_id){
                            self.vehicle_id = {text:data.content.vehicle,value:data.content.vehicle_id};
                        }
                        console.log(data.content.is_reverse.toLowerCase());
                        self.is_reverse = data.content.is_reverse.toLowerCase();

                        // self.dateChanged(self.post_date);
                        self.header_desc = data.content.description;
                        self.batch = data.content.batch;
                        self.journal_type = data.content.journal_type;
                        setTimeout(function(){
                            self.accountCanChanged = true;
                        },2000);
                        var journalItems = data.content.journalItems;
                        self.rows = [];

                        for (var i = 0;i<journalItems.length;i++) {

                          var credit = Number(journalItems[i].credit.replace(/\,/g,""));
                          var debit = Number(journalItems[i].debit.replace(/\,/g,""));
                            self.rows.push({
                                journal_item_id:journalItems[i].journal_item_id,
                                account:{
                                    text:journalItems[i].account_code_description,
                                    value:journalItems[i].account_id
                                },
                                account_error_msg:"",
                                debit:journalItems[i].debit,
                                debit_error_msg:"",
                                credit:journalItems[i].credit,
                                credit_error_msg:"",
                                description:journalItems[i].description,
                                description_error_msg:"",
                                debitDisabled:(debit != 0)?0:1,
                                creditDisabled:(credit != 0)?0:1,
                                vehicle_id:journalItems[i].vehicle_id != null ? {text:journalItems[i].vehicle,value:journalItems[i].vehicle_id}:'',
                                vehicle_error_msg:'',
                                is_cap_cost:journalItems[i].capital_cost == 'yes' ? true : false
                            });
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'journal-by-id')
                }
            });
        },
        onSearchAsset(search, loading) {
            var self = this;
            if (search.length > 3) {
                loading(true);
                self.searchField(loading, search, 'vehicle');
            }

        },
        onDebitInput($event,index) {
            var self = this;
            if (self.rows[index].debit.trim() == "") {
                self.rows[index].debitDisabled = 0;
                self.rows[index].creditDisabled = 0;
            }else{
                self.rows[index].creditDisabled = 1;
            }
        },
        onCreditInput($event,index) {
            var self = this;
            if (self.rows[index].credit.trim() == "") {
                self.rows[index].debitDisabled = 0;
                self.rows[index].creditDisabled = 0;
            }else{
                self.rows[index].debitDisabled = 1;
            }
        },
        // dateChanged:function(evt){
        //     var self = this;
        //     self.fiscal_date = '';
        //     console.log(evt);
        //     console.log(self.formatDate(evt));
        //     self.fiscal_date = self.formatDate(evt);
        // },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;

            return [ month,year].join('/');
        },
        addCpiedRows:function(){
            var self = this;
            var clipText = self.jedescription;
            var dataArr = [];
            var accountArr = [];
            var unitArr = [];
            if (clipText != ''){
                var valueAdded = false;
                for(var i = 0;i<self.rows.length;i++) {
                    if (self.rows[i].account != '' && (self.rows[i].debit != 0 || self.rows[i].credit != 0)){
                        valueAdded = true;
                    }
                }
                if(!valueAdded){
                    self.rows = [];
                }
            }else{
                return;
            }
            // var clipRows = clipText.split(String.fromCharCode(13));
            var clipRows = clipText.split('\n');

            for (var i=0; i<clipRows.length; i++) {
                // var clipData = clipRows[i].split(String.fromCharCode(9));
                var clipData = clipRows[i].split('\t');

                if (clipData[0] != ''){
                    dataArr.push({
                        account:clipData[0],
                        credit:self.amountFormat(clipData[4]),
                        description:clipData[1],
                        debit:self.amountFormat(clipData[3]),
                        vehicle_id:clipData[2]
                    });
                    accountArr.push(clipData[0]);
                    if (clipData[2] != ''){
                        unitArr.push(clipData[2]);
                    }
                }

                // console.log(clipData);
                // var glValue = '';
                // var vehicle = '';
                //
                console.log(dataArr);

            }

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/fetch-gl-unit-data",
                type: "POST",
                headers: this.ajxHeaders,
                data:{
                    unit:unitArr,
                    account:accountArr
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.gl != undefined) {
                        self.glAccountArr = data.gl;
                    }
                    if (data.unit != undefined) {
                        self.allVehicleArr = data.unit;
                    }

                    if (dataArr.length){
                        var glValue = '';
                        // var vehicle = '';
                        for (var j=0; j<dataArr.length; j++) {
                            var vehicle = '';
                            if (dataArr[j]['account'] != undefined && dataArr[j]['account'] != ''){
                                $.each(self.glAccountArr, function (key, value) {
                                    if (value.code == dataArr[j]['account']) {
                                        glValue = {
                                            value: value.value,
                                            text: value.text,
                                        };
                                    }
                                });
                            }

                            if (dataArr[j]['vehicle_id'] != undefined && dataArr[j]['vehicle_id'] != ''){
                                $.each(self.allVehicleArr, function (key, value) {
                                    if (value.unit_no == dataArr[j]['vehicle_id']) {
                                        vehicle = {
                                            value: value.value,
                                            text: value.text
                                        };
                                    }
                                });
                            }

                            if (glValue != ''){
                                self.rows.push({
                                    journal_item_id:0,
                                    account:glValue,
                                    account_error_msg:"",
                                    debit:dataArr[j]['debit'],
                                    debit_error_msg:"",
                                    credit:dataArr[j]['credit'],
                                    credit_error_msg:"",
                                    description:dataArr[j]['description'],
                                    description_error_msg:"",
                                    debitDisabled:dataArr[j]['credit'] != 0 ? 1 :0,//amount format change
                                    creditDisabled:dataArr[j]['debit'] != 0 ? 1 :0,//amount format change
                                    vehicle_id:vehicle,
                                    vehicle_error_msg:'',
                                    is_cap_cost:false
                                });
                            }
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.rows.push({
                        journal_item_id:0,
                        account:"",
                        account_error_msg:"",
                        debit:"",
                        debit_error_msg:"",
                        credit:"",
                        credit_error_msg:"",
                        description:"",
                        description_error_msg:"",
                        debitDisabled:0,
                        creditDisabled:0,
                        vehicle_id:'',
                        vehicle_error_msg:'',
                        is_cap_cost:false
                    });
                    self.generateStatusCodeMessage(jqXHR,false,'journal-by-id')
                }
            });

            self.jedescription = '';

        },
        leaveFocusAmt:function(evt, index,flag) {
            var self = this;
            evt = (evt) ? evt : window.event;
            if (evt.target.value != "") {
                if (flag == "credit") {
                    if(evt.target.value.indexOf(",") == -1) {
                        self.rows[index].credit = self.amountFormat(evt.target.value);
                    } else {
                        self.rows[index].credit = evt.target.value.replace(/\,/g,"");
                        self.rows[index].credit = self.amountFormat(self.rows[index].credit);
                    }
                }else{
                    if(evt.target.value.indexOf(",") == -1) {
                        self.rows[index].debit = self.amountFormat(evt.target.value);
                    } else {
                        self.rows[index].debit = evt.target.value.replace(/\,/g,"");
                        self.rows[index].debit = self.amountFormat(self.rows[index].debit);
                    }
                }
            }
        },

    }
}
</script>



// WEBPACK FOOTER //
// src/components/accounting/JournalCreate.vue